import styled from 'styled-components';
import { Controller, useForm } from 'react-hook-form';
import Select from 'react-select';
import { UserFavorList } from '../../../components/user/favor/user.favor.company.list';
import { useEffect, useState } from 'react';
import {
  fetchPreferenceCompanyList,
  fetchPreferenceCompanyRegistList,
} from '../../../api/preference';
import { addressCollection } from '../../../utils/address';
import { Button } from '../../../components/items/Button';

interface CompanyRegistListResponse {
  id: number;
  cityProvince: string;
  district: string;
  name: string;
}

const UserFavorCompList = () => {
  const [listData, setListData] = useState<CompanyRegistListResponse[]>([]);

  const getCompanyRegistList = async () => {
    try {
      const response = await fetchPreferenceCompanyRegistList();
      console.log(response);

      setListData(response);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getCompanyRegistList();
  }, []);

  return (
    <Container>
      <Title>
        <span>등록된 선호 회사 목록</span>
        <span className="total-item"></span>
      </Title>
      <UserFavorList
        datas={listData}
        onRegisterSuccess={getCompanyRegistList}
      />
    </Container>
  );
};

export default UserFavorCompList;

const Container = styled.div`
  padding: 2.4rem 1.5rem;
`;

const Title = styled.div`
  padding: 1.2rem 0 1.6rem;
  span {
    font-size: 1.6rem;
    font-weight: 700;
  }
`;
